export default __webpack_public_path__ + "static/media/3.05e6a7fb.svg";